import React from 'react';
import Style from './backgroundInput.module.css';
import useAppContext from '../../../../../../context/useAppContext';
import { UploadPreviewImage } from '../../../../../../components/upload/components/uploadPreview';
import UploadImage from '../../../../../../components/gallery/uploadImg';

import GalleryModal from '../../../../../../components/gallery';

export default function ImageInput({ label, value, onChange = () => {}, ...params }) {
    const [{ organization }] = useAppContext();
    const [openModal, setOpenModal] = React.useState(false);
    const [isDropping, setIsDropping] = React.useState(false);

    const uploadImageUrl = React.useCallback(
        url => {
            onChange(url);
        },
        [onChange]
    );
    return (
        <div className={Style['fileArea']}>
            {label}
            {value ? (
                <UploadPreviewImage
                    fileSrc={value}
                    onDelete={() => {
                        onChange(null);
                        setOpenModal(false);
                    }}
                    onChangeEditImage={null}
                />
            ) : (
                <>
                    <GalleryModal
                        // apiKeyUnsplash={window.weezConfig.unsplash}
                        organization={organization}
                        isOpenModal={openModal}
                        onClose={() => setOpenModal(false)}
                        onSelected={url => uploadImageUrl(url)}
                        onUpload={url => uploadImageUrl(url)}
                        fileType="image"
                    />
                    <div onClick={() => setOpenModal(!isDropping)}>
                        <UploadImage
                            sublabelDropzone={'(max 1Mo)'}
                            maxSize={1048576}
                            noClick
                            onDrop={() => setIsDropping(true)}
                            organization={organization}
                            onUpload={url => uploadImageUrl(url)}
                            onClose={() => setIsDropping(false)}
                            {...params}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
